import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchClientManagementList = (dealerId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/client?dealer=${dealerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CLIENT_MANAGEMENT_LIST,
        ActionTypes.FETCHED_CLIENT_MANAGEMENT_LIST,
        [
          ActionTypes.FETCHED_CLIENT_MANAGEMENT_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchClientManagementInfo = (clientId, dealerId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/client/${clientId}?dealer=${dealerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CLIENT_MANAGEMENT_INFO,
        ActionTypes.FETCHED_CLIENT_MANAGEMENT_INFO,
        [
          ActionTypes.FETCHED_CLIENT_MANAGEMENT_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addClientManagement =
  (data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': '/vehicles/client',
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_CLIENT_MANAGEMENT_INFO,
            [
              ActionTypes.ADDED_CLIENT_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Cliente creado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.ADDED_CLIENT_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const updateClientManagement =
  (id, dealerId, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/vehicles/client/${id}?dealerId=${dealerId}`,
          'authenticated': true,
          'types': [
            ActionTypes.UPDATING_CLIENT_MANAGEMENT_INFO,
            [
              ActionTypes.UPDATED_CLIENT_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Cliente actualizado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.UPDATED_CLIENT_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'PUT',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const deleteClientManagement = (id, dealerId, dealerReserve) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/client/${id}?dealerId=${dealerId}&dealerReserve=${dealerReserve}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_CLIENT_MANAGEMENT_INFO,
        [
          ActionTypes.DELETED_CLIENT_MANAGEMENT_INFO,
          MessageActions.addMessageBoxInfo(
            'Cliente eliminado satisfactoriamente'
          ),
        ],
        [
          ActionTypes.DELETED_CLIENT_MANAGEMENT_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const fetchContributorTypes = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/vehicles/contributor-types',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CONTRIBUTOR_TYPES,
        ActionTypes.FETCHED_CONTRIBUTOR_TYPES,
        [
          ActionTypes.FETCHED_CONTRIBUTOR_TYPES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchProvinceTypes = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/vehicles/provinces-codes',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_PROVINCES,
        ActionTypes.FETCHED_PROVINCES,
        [
          ActionTypes.FETCHED_PROVINCES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchCitiesCodes = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/vehicles/cities-codes',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CITIES_CODES,
        ActionTypes.FETCHED_CITIES_CODES,
        [
          ActionTypes.FETCHED_CITIES_CODES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchClientTypes = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/vehicles/client-types-codes',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_CLIENT_TYPES,
        ActionTypes.FETCHED_CLIENT_TYPES,
        [
          ActionTypes.FETCHED_CLIENT_TYPES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchVerifyFloatClient = (clientId, dealerId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/verify-float-client/${clientId}/${dealerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VERIFY_FLOAT_CLIENT,
        ActionTypes.FETCHED_VERIFY_FLOAT_CLIENT,
        [
          ActionTypes.FETCHED_VERIFY_FLOAT_CLIENT_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearClientManagement = () => ({
  'type': ActionTypes.CLEAR_CLIENT_MANAGEMENT_INFO,
});

export const setClientValue = (name, value) => ({
  'type': ActionTypes.SET_CLIENT_INFO_FORM,
  'payload': {name, value},
});
